import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";
import { MEMBERSHIP_FAQ } from "../../data/membership";

export const MembershipFAQ = () => (
  <section className="py-16 border-t border-zinc-800/60" data-testid="membership-faq">
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-8">
        Membership FAQ
      </h2>
      <Accordion type="single" collapsible className="space-y-3">
        {MEMBERSHIP_FAQ.map((item, i) => (
          <AccordionItem
            key={item.q}
            value={`faq-${i}`}
            className="bg-[#121212] border border-zinc-800 rounded-sm px-5"
          >
            <AccordionTrigger className="text-white text-left hover:no-underline" data-testid={`membership-faq-q-${i}`}>
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 leading-relaxed">{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
